import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-product-offer',
  templateUrl: './product-offer.component.html',
  styleUrls: ['./product-offer.component.css']
})
export class ProductOfferComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  goToCalendly(){
    window.open('https://calendly.com/voy-jaleas/30min?month=2023-02');
  }

}
